import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueRouter from 'vue-router';
import Snotify from 'vue-snotify';
import 'vue-snotify/styles/material.css'
import { HorizontalBar  } from 'vue-chartjs'
import { Doughnut } from 'vue-chartjs'
import { Bar } from 'vue-chartjs'
import { Line } from 'vue-chartjs'
import 'chart.piecelabel.js';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { max } from 'moment';

Vue.use(Loading);
Vue.use(Snotify);

Vue.component('hor-bar-chart', {
    extends: HorizontalBar,
    props: ['data', 'options'],
    mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.data, this.options)
    },
    methods: {
        handle(point, event) {
            const item = event[0]
            this.$emit('on-receive', {
                index: item._index,
                backgroundColor: item._view.backgroundColor,
                value: this.values[item._index]
            })
        }
    },
    watch: {
        data: function () {
            this._data._chart.destroy();
            this.renderChart(this.data, this.options);
        }
    },
})

Vue.component('bar-chart', {
    extends: Bar,
    props: ['data', 'options'],
    mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.data, this.options)
    },
    methods: {
        handle(point, event) {
            const item = event[0]
            this.$emit('on-receive', {
                index: item._index,
                backgroundColor: item._view.backgroundColor,
                value: this.values[item._index]
            })
        }
    },
    watch: {
        data: function () {
            this._data._chart.destroy();
            this.renderChart(this.data, this.options);
        }
    },
})

Vue.component('line-chart', {
    extends: Line,
    props: ['data', 'options'],
    mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.data, this.options)
    },
    methods: {
        handle(point, event) {
            const item = event[0]
            this.$emit('on-receive', {
                index: item._index,
                backgroundColor: item._view.backgroundColor,
                value: this.values[item._index]
            })
        }
    },
    watch: {
        data: function () {
            this._data._chart.destroy();
            this.renderChart(this.data, this.options);
        }
    },
})

Vue.component('pie-chart', {
    extends: Doughnut,
    props: ['data', 'options'],
    mounted() {
        // this.chartData is created in the mixin
        this.renderChart(this.data, this.options)
    },
    watch: {
        data: function () {
            this._data._chart.destroy();
            this.renderChart(this.data, this.options);
        }
    },
    methods: {
        handle(point, event) {
            const item = event[0]
            this.$emit('on-receive', {
                index: item._index,
                backgroundColor: item._view.backgroundColor,
                value: this.values[item._index]
            })
        }
    }
})

Vue.filter('scaleArray', function (array) {
    var maxValue = Math.max(...array);
    var parts = maxValue.toString().split('.');
    var scale = parts[0].length;
    var devider = 1;
    var text = 'NOK'
    switch (true) {
        case scale > 3 && scale <= 6:
            devider = Math.pow(10, 3);
            text = 'TUSEN NOK'
            break;
        case scale <= 9:
            devider = Math.pow(10, 6);
            text = 'MILL NOK'
            break;
        case scale > 9:
            devider = Math.pow(10, 9);
            text = 'MRD NOK'
            break;
        default:
    }
    var scaledArray = array.map(el => parseFloat(el / devider ).toFixed(1))

    return {
        Array: scaledArray,
        Scale: text
    };
});


Vue.filter('toKilo', function (value) {
    return Math.round(value / 1000).toString();
});

Vue.filter('toMega', function (value) {
    return Math.round(value / 1000000).toString();
});

Vue.filter('toMegaDecimal', function (value) {
    return parseFloat(value / 1000000).toFixed(1).toString();
});

Vue.filter('toGiga', function (value) {
    return parseFloat(value / 1000000000).toFixed(1).toString();
});

Vue.filter('separator', function (value) {
    try {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } catch (e) {
        return value;
    }
});

Vue.filter('round', function (value) {
    if (value) {
        return Math.round(value).toString();
    }
    return value;
});

Vue.filter('formatPercentage', function (value) {
    if (Math.abs(value) >= 1000) {
        return '';
    }
    if (value > 0) {
        return '+' + value + '%';
    }
    return value + '%';
});

Vue.filter('formatYear', function (value) {
    if (moment().year() === value) {
        return 'Hittil i år';
    }
    return value;
});

const colors = ['#00588d', '#0099cc', '#b4dee8', '#006971', '#b4ab15', '#d2d338', '#af2009', '#b4511f', '#e48f00', '#d5ecf2', '#ffda00', '#f5f1db' ]
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des']
const monthNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

var app = new Vue({
    el: '#statisticOverview',
    components: {
        PulseLoader
    },

    data: {
        isLoading: true,
        statisticData: null,
        selectedYearData: null,
        selectedFishId: null,
        selectedFishConservations: null,
        selectedConservation: null,
        customDbQuery: null,
        fishGraphComments: null,
        yearToCompare: null,

        isMobileScreen: window.innerWidth < 576 ? true : false,

        fishStatisticArray: [],
        pieChartDataArray: [],
        gearDataArray: [],

        dynamicBarLabels: [],
        dynamicBarData: [],
        dynamicBarLYData: [],
        dynamicBarColors: [],

        dynamicPieLabels: [],
        dynamicPieData: [],
        dynamicPieColors: [],
        pieChartOptions: {
            hoverBorderWidth: 20,
            legend: {
                display: true,
                onClick: null,
                position: window.innerWidth >= 768 ? 'right' : 'top',
                align: 'center',
                labels: {
                    usePointStyle: true,
                    fontFamily: 'Poppins',
                    fontSize: window.innerWidth >= 768 ? 16 : 12,
                    pointStyle: 'circle',
                    padding: window.innerWidth >= 768 ? 20 : 10,
                }
            },
            tooltips: {
                enabled: true,
                mode: 'single',
                titleFontFamily: 'Poppins',
                titleFontSize: 16,
                titleAlign: 'right',
                bodyFontFamily: 'Poppins',
                bodyFontSize: 30,
                bodyFontColor: '#00B5F1',
                bodyFontStyle: 'bold',
                bodyAlign: 'right',
                footerFontFamily: 'Poppins',
                footerColor: '#fff',
                footerAlign: 'right',
                caretSize: 10,
                callbacks: {
                    title: function (tooltipItem, data) {
                        return data['labels'][tooltipItem[0]['index']];
                    },
                    label: function (tooltipItems, data) {
                        var value = Math.round(data['datasets'][0]['data'][tooltipItems['index']] / 1000000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');;
                        return ' ' + value;
                    },
                    footer: function () {
                        return ' MNOK';
                    }
                }
            },
            pieceLabel: {
                //render: function (d) { return d.label + " (" + d.percentage + "%)" },
                render: function (d) { return "  " + d.percentage + "%  " },
                //precision: 1,
                fontColor: '#000',
                fontSize: 18,
                position: window.innerWidth >= 576 ? 'outside' : 'inside',
                segment: true
            },
            responsive: true,
            maintainAspectRatio: false,
            onClick: (evt, item) => {
                let index = item[0]["_index"];
                let name = item[0]["_chart"].data.labels[index];
                let votes = item[0]["_chart"].data.datasets[0].data[index];
                console.log(name);
                console.log(votes);
            }
        },

        fishValueChartOptions: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    gridLines: {
                        display: false
                    }
                }],
                xAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    gridLines: {
                        display: false
                    },
                }]
            },
            legend: {
                display: true,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    fontFamily: 'Poppins',
                    fontSize: window.innerWidth >= 768 ? 14 : 12,
                    pointStyle: 'circle'
                }
            },
            tooltips: {
                enabled: true,
                mode: 'single',
                displayColors: false,
                titleFontFamily: 'Poppins',
                titleFontSize: 16,
                titleAlign: 'right',
                bodyFontFamily: 'Poppins',
                bodyFontSize: 30,
                bodyFontColor: '#00B5F1',
                bodyFontStyle: 'bold',
                bodyAlign: 'right',
                footerFontFamily: 'Poppins',
                footerColor: '#fff',
                footerAlign: 'right',
                caretSize: 10,
                callbacks: {
                    label: function (tooltipItems, data) {
                        return parseFloat(tooltipItems.yLabel).toFixed(2);
                    },
                    footer: function () {
                        return ' NOK';
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            height: 200
        },

        fishWeightChartOptions: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function (value, index, values) {
                            try {
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                            } catch (e) {
                                return value;
                            }
                        }
                    },
                    gridLines: {
                        display: false
                    }
                }],
                xAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    gridLines: {
                        display: false
                    },
                }]
            },
            legend: {
                display: true,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    fontFamily: 'Poppins',
                    fontSize: window.innerWidth >= 768 ? 14 : 12,
                    pointStyle: 'circle'
                }
            },
            tooltips: {
                enabled: true,
                mode: 'single',
                displayColors: false,
                titleFontFamily: 'Poppins',
                titleFontSize: 16,
                titleAlign: 'right',
                bodyFontFamily: 'Poppins',
                bodyFontSize: 30,
                bodyFontColor: '#00B5F1',
                bodyFontStyle: 'bold',
                bodyAlign: 'right',
                footerFontFamily: 'Poppins',
                footerColor: '#fff',
                footerAlign: 'right',
                caretSize: 10,
                callbacks: {
                    title: function (tooltipItem, data) {
                        return data['labels'][tooltipItem[0]['index']];
                    },
                    label: function (tooltipItems, data) {
                        try {
                            return Math.round(tooltipItems.yLabel).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        } catch (e) {
                            return Math.round(tooltipItems.yLabel);
                        }
                    },
                    footer: function () {
                        return ' TONN';
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            height: 200
        },

        gearChartOptions: {
            hoverBorderWidth: 20,
            legend: {
                display: true,
                onClick: null,
                position: window.innerWidth >= 768 ? 'right' : 'top',
                align: 'center',
                labels: {
                    usePointStyle: true,
                    fontFamily: 'Poppins',
                    fontSize: window.innerWidth >= 768 ? 16 : 12,
                    pointStyle: 'circle',
                    padding: window.innerWidth >= 768 ? 20 : 10,
                }
            },
            tooltips: {
                enabled: true,
                mode: 'single',
                titleFontFamily: 'Poppins',
                titleFontSize: 16,
                titleAlign: 'right',
                bodyFontFamily: 'Poppins',
                bodyFontSize: 30,
                bodyFontColor: '#00B5F1',
                bodyFontStyle: 'bold',
                bodyAlign: 'right',
                footerFontFamily: 'Poppins',
                footerColor: '#fff',
                footerAlign: 'right',
                caretSize: 10,
                callbacks: {
                    title: function (tooltipItem, data) {
                        return data['labels'][tooltipItem[0]['index']];
                    },
                    label: function (tooltipItems, data) {
                        var value = Math.round(data['datasets'][0]['data'][tooltipItems['index']] / 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        return '  ' + value;
                    },
                    footer: function () {
                        return ' TONN';
                    }
                }
            },
            pieceLabel: {
                //render: function (d) { return d.label + " (" + d.percentage + "%)" },
                render: function (d) {
                    if (d.percentage < 0.5) {
                        return "";
                    }
                    return "  " + Math.round(d.percentage) + "%  ";
                },
                precision: 0,
                overlap: false,
                showActualPercentages: false,
                fontColor: '#000',
                fontSize: 18,
                position: window.innerWidth >= 576 ? 'outside' : 'inside',
                segment: true
            },
            responsive: true,
            maintainAspectRatio: false,
            onClick: (evt, item) => {
                let index = item[0]["_index"];
                let name = item[0]["_chart"].data.labels[index];
                let votes = item[0]["_chart"].data.datasets[0].data[index];
                console.log(name);
                console.log(votes);
            }
        },

        functionsInExecution: []
    },

    watch: {
        statisticData: function (val) {
            var maxYear = Math.max.apply(Math, val.map(function (o) { return o.Year; }))
            this.selectYearData(maxYear);
            this.updateBarCharData();
        },

        selectedYearData: function (val) {
            this.updateBarCharData();
        },

        selectedFishData: function (val) {
            // console.log(val);
        },

        pieChartDataArray: function (val) {
            //console.log(val);
        },

        selectedFishId: function (val) {
            var self = this;
            if (val) {
                self.selectedConservation = Object.keys(self.selectedFishConservations)[0];
                self.refreshFishData();
            }
            else {
                self.refreshPieChartData(self.selectedYearData.Year);
            }
        },

        fishStatisticArray: function (val) {
            //console.log(val);
        },

        gearDataArray: function (val) {

        },

        selectedConservation: function (val) {

        },

        functionsInExecution: function (val) {
            //console.log(val);
        },

        yearToCompare: function (val) {
            var self = this;
            if (val && !self.isFishDataLoaded) {
                self.getFishData(self.selectedFishId, self.selectedConservation, true);
            }
            if (val && !self.yearToCompareGearData) {
                self.getGearData(self.selectedFishId, true);
            }
        },
    },

    computed: {
        yearsList: function () {
            if (this.statisticData !== null) {
                return this.statisticData.map(td => td.Year);
            }
            return [];
        },

        otherYears: function () {
            if (this.yearsList !== []) {
                return this.yearsList.filter(yr => yr !== this.selectedYearData.Year)
            }
            return [];
        },

        previousYear: function () {
            return this.selectedYearData.Year - 1;
        },

        nextYear: function () {
            return this.selectedYearData.Year + 1;
        },

        barDynamicData: function () {
            return {
                labels: this.dynamicBarLabels,
                datasets: [
                    {
                        label: 'Samme periode    ',
                        backgroundColor: "#005680",
                        pointBackgroundColor: 'white',
                        borderWidth: 1,
                        barPercentage: 0.7,
                        pointBorderColor: '#249EBF',
                        data: this.dynamicBarLYData,
                    },
                    {
                        label: 'Totalt pr år',
                        backgroundColor: "#00B5F1",
                        pointBackgroundColor: 'white',
                        borderWidth: 1,
                        barPercentage: 0.7,
                        pointBorderColor: '#249EBF',
                        data: this.dynamicBarData
                    }
                ]
            }
        },

        yearsToCompare: function () {
            if (this.yearToCompare) {
                return [this.selectedYearData.Year, this.yearToCompare];
            }
            return [this.selectedYearData.Year];
        },

        barCompareDynamicData: function () {
            return {
                labels: this.compareBarCharData.Labels,
                datasets: [
                    {
                        label: this.compareBarCharData.Scale,
                        backgroundColor: this.compareBarCharData.Colors,
                        pointBackgroundColor: 'white',
                        borderWidth: 1,
                        barPercentage: this.compareBarCharData.Labels.length > 1 ? 0.4 : 0.2,
                        pointBorderColor: '#249EBF',
                        data: this.compareBarCharData.Data,
                    }
                ]
            }
        },

        baChartComputedOptions: function () {
            return {
                title: {
                    display: true,
                    text: this.compareBarCharData ? this.compareBarCharData.Scale : "MRD NOK",
                    fontFamily: 'Poppins',
                    fontSize: 16,
                    fontColor: '#005680'
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: false
                        }
                    }],
                    xAxes: [{
                        stacked: false,
                        ticks: {
                            beginAtZero: true,
                        },
                        gridLines: {
                            display: true
                        }
                    }
                    ]
                },
                legend: {
                    display: this.selectedFishId ? false : true,
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                        fontFamily: 'Poppins',
                        fontSize: window.innerWidth >= 768 ? 14 : 12,
                        pointStyle: 'circle'
                    }
                },
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    displayColors: false,
                    titleFontFamily: 'Poppins',
                    titleFontSize: 16,
                    titleAlign: 'right',
                    bodyFontFamily: 'Poppins',
                    bodyFontSize: 30,
                    bodyFontColor: '#00B5F1',
                    bodyFontStyle: 'bold',
                    bodyAlign: 'right',
                    footerFontFamily: 'Poppins',
                    footerColor: '#fff',
                    footerAlign: 'right',
                    caretSize: 10,
                    callbacks: {
                        title: function (tooltipItem, data) {
                            return data['labels'][tooltipItem[0]['index']];
                        },
                        label: function (tooltipItem, data) {
                            return '  ' + tooltipItem.xLabel;
                        },
                        footer: function () {
                            return "";
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                //onClick: (evt, item) => {
                //    let index = item[0]["_index"];
                //    let year = item[0]["_chart"].data.labels[index];
                //    let votes = item[0]["_chart"].data.datasets[0].data[index];
                //    var event = new CustomEvent("setYear", { 'detail': year }); //set year on bar click

                //    // Dispatch/Trigger/Fire the event
                //    document.dispatchEvent(event);
                //},
                height: 250
            }
        },

        compareBarCharData() {
            if (this.compareFishTotalValue) {
                var dynamicLabels = this.yearsToCompare;
                var dynamicBarData = this.compareFishTotalValue.Array;
                var dynamicBarColors = ['#00B5F1', '#005680'];
                var dynamicText = this.compareFishTotalValue.Scale;
                return {
                    Labels: dynamicLabels,
                    Data: dynamicBarData,
                    Colors: dynamicBarColors,
                    Scale: dynamicText
                }
            }
            return null;
        },

        pieDynamicData: function () {
            if (this.pieChartData) {
                return {
                    hoverBackgroundColor: "red",
                    hoverBorderWidth: 10,
                    labels: this.pieChartData.Data.map(td => td.Name[0] + td.Name.substr(1).toLowerCase()),
                    datasets: [
                        {
                            label: "Data One",
                            backgroundColor: this.pieChartData.Data.map(td => colors[td.Rank - 1]),
                            data: this.pieChartData.Data.map(td => td.Value)
                        }
                    ]
                }
            }
            return null;
        },

        fishPriceDynamicData: function () {
            if (this.selectedFishData) {
                if (this.yearToCompareFishData) {
                    return {
                        labels: months,
                        datasets: [
                            {
                                barPercentage: 0.4,
                                label: this.selectedFishData.Year + '     ',
                                backgroundColor: '#ffffff00',
                                pointBackgroundColor: 'white',
                                borderWidth: 3,
                                borderColor: '#00B5F1',
                                pointBorderColor: '#249EBF',
                                data: monthNumbers.flatMap(m => this.selectedFishData.Data.map(sfd => sfd.Month).includes(m) ? this.selectedFishData.Data.find(x => x.Month === m).Value : "N/A")
                            }
                            ,
                            {
                                barPercentage: 0.4,
                                label: this.yearToCompareFishData.Year,
                                backgroundColor: '#ffffff00',
                                pointBackgroundColor: 'white',
                                borderWidth: 3,
                                borderColor: '#005680',
                                pointBorderColor: '#005680',
                                data: monthNumbers.flatMap(m => this.yearToCompareFishData.Data.map(sfd => sfd.Month).includes(m) ? this.yearToCompareFishData.Data.find(x => x.Month === m).Value : "N/A")
                            }
                        ]
                    }
                }
                else {
                    return {
                        labels: months,
                        datasets: [
                            {
                                barPercentage: 0.4,
                                label: this.selectedFishData.Year,
                                backgroundColor: '#ffffff00',
                                pointBackgroundColor: 'white',
                                borderWidth: 3,
                                borderColor: '#00B5F1',
                                pointBorderColor: '#249EBF',
                                data: monthNumbers.flatMap(m => this.selectedFishData.Data.map(sfd => sfd.Month).includes(m) ? this.selectedFishData.Data.find(x => x.Month === m).Value : "N/A")
                            }
                        ]
                    }
                }

            }
            return null;
        },

        fishWightDynamicData: function () {
            if (this.selectedFishData) {
                if (this.yearToCompareFishData) {
                    return {
                        labels: months,
                        datasets: [
                            {
                                barPercentage: 0.4,
                                label: this.selectedFishData.Year + '     ',
                                backgroundColor: '#00B5F1',
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                pointBorderColor: '#249EBF',
                                data: monthNumbers.flatMap(m => this.selectedFishData.Data.map(sfd => sfd.Month).includes(m) ? this.selectedFishData.Data.find(x => x.Month === m).Weight / 1000 : "N/A")
                            }
                            ,
                            {
                                barPercentage: 0.4,
                                label: this.yearToCompareFishData.Year,
                                backgroundColor: '#005680',
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                pointBorderColor: '#249EBF',
                                data: monthNumbers.flatMap(m => this.yearToCompareFishData.Data.map(sfd => sfd.Month).includes(m) ? this.yearToCompareFishData.Data.find(x => x.Month === m).Weight / 1000 : "N/A")
                            }
                        ]
                    }
                }
                else {
                    return {
                        labels: months,
                        datasets: [
                            {
                                barPercentage: 0.4,
                                label: this.selectedFishData.Year + '     ',
                                backgroundColor: monthNumbers.map(m => m === moment().month() + 1 ? '#00B5F1' : '#005680'),
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                pointBorderColor: '#249EBF',
                                data: monthNumbers.flatMap(m => this.selectedFishData.Data.map(sfd => sfd.Month).includes(m) ? this.selectedFishData.Data.find(x => x.Month === m).Weight / 1000 : "N/A")
                            }
                        ]
                    }
                }
            }
            return null;
        },

        gearDynamicData: function () {
            if (this.gearChartData) {
                return {
                    hoverBackgroundColor: "red",
                    hoverBorderWidth: 10,
                    labels: this.gearChartData.Data.filter(td => td.Value > 0).map(td => td.Name[0] + td.Name.substr(1).toLowerCase()),
                    datasets: [
                        {
                            label: this.selectedFishData.Year,
                            backgroundColor: this.gearChartData.Data.map(td => colors[td.Rank - 1]),
                            data: this.gearChartData.Data.filter(td => td.Value > 0).map(td => td.Value)
                        }
                    ]
                }
            }
            return null;
        },

        gearCompareDynamicData: function () {
            if (this.yearToCompareGearData) {
                return {
                    hoverBackgroundColor: "red",
                    hoverBorderWidth: 10,
                    labels: this.yearToCompareGearData.Data.filter(td => td.Value > 0).map(td => td.Name[0] + td.Name.substr(1).toLowerCase()),
                    datasets: [
                        {
                            label: this.yearToCompare,
                            // backgroundColor: this.yearToCompareGearData.Data.map(td => colors[td.Rank - 1]),
                            backgroundColor: this.orderedChartColors[1].map(x => x.Color),
                            data: this.yearToCompareGearData.Data.filter(td => td.Value > 0).map(td => td.Value)
                        }
                    ]
                }
            }
            return null;
        },

        orderedChartColors: function () {
            var dataSets = [];
            dataSets.push(this.gearChartData.Data);
            dataSets.push(this.yearToCompareGearData.Data);
            var colorOrder = [];
            var colorIndex = 0;
            dataSets.forEach(function(dataSet) {
                dataSet.forEach(function(data) {
                    if (!(colorOrder.some(x => x.Name == data.Name))) {
                        colorOrder.push({'Name' : data.Name, 'Color' : colors[colorIndex]});
                        colorIndex++;
                    }
                });
            });
            var output = dataSets.map(x => x.map(y => ({'Name' : y.Name, 'Color' : colorOrder.find(z => z.Name == y.Name).Color })))
            return output;
        },

        difference: function () {
            if (this.statisticData && this.selectedYearData) {
                var previousYear = this.statisticData.filter(sd => sd.Year === (this.previousYear))[0]
                if (previousYear) {
                    if (this.selectedYearData.Year === moment().year()) {
                        var previousValue = previousYear.Data.ValueToDate;
                        var previousWeight = previousYear.Data.WeightToDate;
                        var previousValueNorsk = previousYear.Data.ValueNorToDate;
                        var previousValueForeign = previousYear.Data.ValueForToDate;
                        var previousValueBanknotes = previousYear.Data.AntSedler;
                        var bankNotesCalculated = previousValue * previousValueBanknotes / previousYear.Data.TotalVerdi; // aprox. value since there is no value in database
                        return {
                            ValueNorsk: parseFloat((this.selectedYearData.Data.ValueNorToDate - previousValueNorsk) / previousValueNorsk * 100).toFixed(1),
                            ValueForeign: parseFloat((this.selectedYearData.Data.ValueForToDate - previousValueForeign) / previousValueForeign * 100).toFixed(1),
                            ValueBanknotes: parseFloat((this.selectedYearData.Data.AntSedler - bankNotesCalculated) / bankNotesCalculated * 100).toFixed(1),
                            Value: parseFloat((this.selectedYearData.Data.ValueToDate - previousValue) / previousValue * 100).toFixed(1),
                            Weight: parseFloat((this.selectedYearData.Data.WeightToDate - previousWeight) / previousWeight * 100).toFixed(1)
                        }
                    }
                    else {
                        var previousValue = previousYear.Data.TotalVerdi;
                        var previousWeight = previousYear.Data.TotalVekt;
                        var previousValueNorsk = previousYear.Data.ValueNorsk;
                        var previousValueForeign = previousYear.Data.ValueForeign;
                        var previousValueBanknotes = previousYear.Data.AntSedler;
                        return {
                            ValueNorsk: parseFloat((this.selectedYearData.Data.ValueNorsk - previousValueNorsk) / previousValueNorsk * 100).toFixed(1),
                            ValueForeign: parseFloat((this.selectedYearData.Data.ValueForeign - previousValueForeign) / previousValueForeign * 100).toFixed(1),
                            ValueBanknotes: parseFloat((this.selectedYearData.Data.AntSedler - previousValueBanknotes) / previousValueBanknotes * 100).toFixed(1),
                            Value: parseFloat((this.selectedYearData.Data.TotalVerdi - previousValue) / previousValue * 100).toFixed(1),
                            Weight: parseFloat((this.selectedYearData.Data.TotalVekt - previousWeight) / previousWeight * 100).toFixed(1)
                        }
                    }

                }
            }
            return false;
        },

        selectedFishData: function () {
            var selectedFish = this.fishStatisticArray.find(fs => fs.Id === this.selectedFishId && fs.Year === this.selectedYearData.Year && fs.Conservation === this.selectedConservation);
            if (selectedFish !== undefined) {
                return selectedFish;
            }
            return null;
        },

        yearToCompareFishData: function () {
            var compareFishData = this.fishStatisticArray.find(fs => fs.Id === this.selectedFishId && fs.Year === this.yearToCompare && fs.Conservation === this.selectedConservation);
            if (compareFishData !== undefined) {
                return compareFishData;
            }
            return null;
        },

        selectedFishTotalWeight: function () {
            if (this.selectedFishData) {
                var monthlyWeights = this.selectedFishData.Data.map(sfd => (sfd.Weight / 1000));
                return monthlyWeights.reduce((a, b) => a + b, 0);
            }
            return null;
        },

        yearToCompareFishTotalWeight: function () {
            if (this.yearToCompareFishData) {
                var monthlyWeights = this.yearToCompareFishData.Data.map(sfd => (sfd.Weight / 1000));
                return monthlyWeights.reduce((a, b) => a + b, 0);
            }
            return null;
        },

        compareFishTotalValue: function () {
            var compareArray = [];
            if (this.selectedFishData) {
                var selectedYearValues = this.selectedFishData.Data.map(sfd => (sfd.MonthValue));
                var sum1 = selectedYearValues.reduce((a, b) => a + b, 0);
                compareArray.push(this.$options.filters.round(sum1));

                if (this.yearToCompareFishData) {
                    var compareYearValues = this.yearToCompareFishData.Data.map(sfd => (sfd.MonthValue));
                    var sum2 = compareYearValues.reduce((a, b) => a + b, 0);
                    compareArray.push(this.$options.filters.round(sum2));
                }
                return this.$options.filters.scaleArray(compareArray);
            }
            return null;
        },

        pieChartData: function () {
            var selectedData = this.pieChartDataArray.find(pc => pc.Year === this.selectedYearData.Year);
            if (selectedData !== undefined) {
                return selectedData;
            }
            return null;
        },

        gearChartData: function () {
            var selectedData = this.gearDataArray.find(gd => gd.Id === this.selectedFishId && gd.Year === this.selectedYearData.Year && gd.Conservation === this.selectedConservation);
            if (selectedData !== undefined) {
                return selectedData;
            }
            return null;
        },

        yearToCompareGearData: function () {
            var compareGearData = this.gearDataArray.find(fs => fs.Id === this.selectedFishId && fs.Year === this.yearToCompare && fs.Conservation === this.selectedConservation);
            if (compareGearData !== undefined) {
                return compareGearData;
            }
            return null;
        },

        isPieChartDataLoaded() {
            var self = this;
            var index = self.pieChartDataArray.findIndex(pc => pc.Year === self.selectedYearData.Year);

            return index !== -1;
        },

        isFishDataLoaded() {
            var self = this;
            var yearToCheck = self.yearToCompare !== null ? self.yearToCompare : self.selectedYearData.Year;
            var index = -1;
            if (self.selectedConservation !== null) {
                index = self.fishStatisticArray.findIndex(fs => fs.Id === self.selectedFishId && fs.Year === yearToCheck && fs.Conservation === self.selectedConservation);
            }
            else {
                index = self.fishStatisticArray.findIndex(fs => fs.Id === self.selectedFishId && fs.Year === yearToCheck);
            }
            return index !== -1;
        },

        isGearDataLoaded() {
            var self = this;
            var index = -1;
            if (self.selectedConservation !== null) {
                index = self.gearDataArray.findIndex(gd => gd.Id === self.selectedFishId && gd.Year === self.selectedYearData.Year && gd.Conservation === self.selectedConservation);
            }
            else {
                index = self.gearDataArray.findIndex(gd => gd.Id === self.selectedFishId && gd.Year === self.selectedYearData.Year);
            }

            return index !== -1;
        },

        isGetFishDataInExecution() {
            var self = this;
            const index = self.functionsInExecution.indexOf(self.getFishData.name + self.selectedFishId + self.selectedConservation);
            return index !== -1;
        },

        isGetGearDataInExecution() {
            var self = this;
            const index = self.functionsInExecution.indexOf(self.getGearData.name + self.selectedFishId + self.selectedConservation);
            return index !== -1;
        }
    },

    methods: {
        getStatisticData: function () {
            var self = this;
            let loader = self.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });

            axios.get('/umbraco/Surface/Statistic/GetStatisticData/')
                .then((response) => {
                    if (response.data !== 'error') {
                        self.statisticData = response.data;
                    }
                    else {
                        console.log('error');
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    }
                    loader.hide();
                })
                .catch(function (error) {
                    console.log(error);
                    self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    loader.hide();
                });
        },

        refreshFishData: function () {
            var self = this;
            self.yearToCompare = null;
            if (self.selectedFishId && !self.isFishDataLoaded) {
                setTimeout(() => {
                    self.getFishData(self.selectedFishId, self.selectedConservation);
                }, 100);
            }
            else if (self.selectedFishId && !self.isGearDataLoaded) {
                setTimeout(() => {
                    self.getGearData(self.selectedFishId);
                }, 100);
            }
        },

        getFishData: function (id, conservation = null, compare = false) {
            var self = this;
            var yearToGet = compare ? self.yearToCompare : self.selectedYearData.Year;
            if (self.functionsInExecution.indexOf(self.getFishData.name + id + conservation) === -1) {
                self.functionsInExecution.push(self.getFishData.name + id + conservation);
                axios.get('/umbraco/Surface/Statistic/GetFishStatisticData/', {
                    params: {
                        fishId: id,
                        year: yearToGet,
                        customQuery: self.customDbQuery,
                        conservation: conservation,
                        quality: '20'
                    }
                })
                    .then((response) => {
                        if (response.data !== 'error') {
                            self.fishStatisticArray.push(response.data);

                            setTimeout(() => {
                                self.getGearData(id);
                            }, 100);
                        }
                        else {
                            console.log('error');
                            self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        }
                        self.removeFromExecution(self.getFishData.name + id + conservation);
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.removeFromExecution(self.getFishData.name + id + conservation);
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    });
            }
        },

        refreshPieChartData: function (year) {
            var self = this;
            if (!self.isPieChartDataLoaded && !self.selectedFishId) {
                setTimeout(() => {
                    self.getPieChartData(year);
                }, 100);
            }
        },

        getPieChartData: function (year = null) {
            var self = this;
            if (self.functionsInExecution.indexOf(self.getPieChartData.name + year) === -1) {
                var loader = self.showDataLoader('pieChartDiv');
                self.functionsInExecution.push(self.getPieChartData.name + year);
                axios.get('/umbraco/Surface/Statistic/GetPieChartData', {
                    params: {
                        year: year
                    }
                })
                    .then((response) => {
                        if (response.data !== 'error') {
                            self.pieChartDataArray.push(response.data);
                        }
                        else {
                            console.log('error');
                            self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        }
                        self.removeFromExecution(self.getPieChartData.name + year);
                        loader.hide();
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.removeFromExecution(self.getPieChartData.name + year);
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        loader.hide();
                    });
            }

        },

        getGearData: function (fishId, compare = false) {
            var self = this;
            var yearToGet = compare ? self.yearToCompare : self.selectedYearData.Year;
            if (self.functionsInExecution.indexOf(self.getGearData.name + fishId) === -1) {
                self.functionsInExecution.push(self.getGearData.name + fishId);
                axios.get('/umbraco/Surface/Statistic/GetGearStatistic/', {
                    params: {
                        fishId: fishId,
                        year: yearToGet,
                        conservation: self.selectedConservation
                    }
                })
                    .then((response) => {
                        if (response.data !== 'error') {
                            self.gearDataArray.push(response.data);
                        }
                        else {
                            console.log('error');
                            self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        }
                        self.removeFromExecution(self.getGearData.name + fishId);
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.removeFromExecution(self.getGearData.name + fishId);
                        self.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    });
            }   
        },

        selectYearData(year) {
            this.selectedYearData = this.statisticData.find(td => td.Year === year);

            this.refreshFishData();

            this.refreshPieChartData(year);
        },

        updateBarCharData() {
            this.dynamicBarLabels = this.statisticData.map(td => td.Year);
            this.dynamicBarData = this.statisticData.map(td => this.$options.filters.toGiga(td.Data.TotalVerdi));
            this.dynamicBarLYData = this.statisticData.map(td => this.$options.filters.toGiga(td.Data.ValueToDate));
            this.dynamicBarColors = this.statisticData.map(td => td.Year === this.selectedYearData.Year ? '#00B5F1' : '#005680');
        },

        updatePieCharData(pieChartData) {
            this.dynamicPieLabels = pieChartData.map(td => td.Name);
            this.dynamicPieData = pieChartData.map(td => td.Value);
            this.dynamicPieColors = pieChartData.map(td => colors[td.Rank - 1]);
        },

        selectFish(id, customQuery, conservations = {"2" : "Fersk"}, comments) {
            var self = this;
            self.selectedFishConservations = self.selectedFishId === id ? null : conservations;
            self.selectedFishId = self.selectedFishId === id ? null : id;
            self.customDbQuery = customQuery;
            self.fishGraphComments = comments;
        },

        selectConservation(id) {
            var self = this;
            self.selectedConservation = id;
            self.refreshFishData();
        },

        selectYearToCompare(year) {
            var self = this;
            self.yearToCompare = self.yearToCompare === year ? null : year;
        },

        displayErrorNotification(error) {
            this.$snotify.error(error, {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        },

        removeFromExecution(functionName) {
            var self = this;
            const index = self.functionsInExecution.indexOf(functionName);
            if (index > -1) {
                self.functionsInExecution.splice(index, 1);
            }
        },

        showDataLoader(container) {
            var self = this;
            var loader = self.$loading.show({
                container: self.$refs[container],
                loader: 'spinner',
                color: '#007bff',
                isFullPage: false
            });
            return loader;
        },

        update(data) {
            //console.log(data);
        }
    },

    created() {
        var self = this
        document.addEventListener("setYear", function (e) {
            //console.log(e.detail);
            self.selectYearData(e.detail)
        });
    },

    mounted() {
        this.getStatisticData();
    }
});


// WEBPACK FOOTER //
// ./Scripts/app/statistic/index.js